'use client'

import {
  navigateWizardRoute,
  useWizardNavigationState,
} from '@/components/_championship/forms/wizard-navigation/store'
import { cn } from '@/lib/utils'
import MobileDropdownNav from './mobile-dropdown-nav'
import { sidebarItems } from './sidebar-items/championship-sidebar-items'

export default function EditContent({
  params,
  pathname,
  router,
  serverInfoFeatureEnabled = true,
}) {
  const options = sidebarItems
    .slice(0, -1)
    .filter(
      (item) =>
        serverInfoFeatureEnabled || item.urlSnippet !== 'server-info',
    )
  const { isNavigating } = useWizardNavigationState()

  return (
    <>
      <div className="tablet:hidden">
        <MobileDropdownNav
          options={options}
          baseUrl={`/manage/${params.communityId}/racing/${params.championshipId}/edit`}
          useWizardNavigation
        />
      </div>

      <div className="flex flex-col max-tablet:hidden">
        <p className="mb-3 text-p-1 font-bold text-neutral-blue-400">Edit</p>

        {options.map((item) => (
          <div
            onClick={() => {
              if (isNavigating) return
              void navigateWizardRoute({
                router,
                href: `/manage/${params.communityId}/racing/${params.championshipId}/edit/${item.urlSnippet}`,
                replace: true,
              })
            }}
            key={item.title}
            className={cn(
              'flex cursor-pointer items-center gap-2 rounded-sm p-2 transition-all hover:bg-neutral-blue-600',
              {
                'pointer-events-none opacity-60': isNavigating,
              },
            )}
          >
            <div
              className={cn(
                'flex aspect-square items-center justify-center rounded-sm bg-neutral-blue-700 stroke-neutral-blue-200 p-1 [&>svg]:size-5',
                {
                  'bg-shades-0 [&>svg]:stroke-neutral-blue-900':
                    pathname.endsWith(item.urlSnippet),
                },
              )}
            >
              {item.icon}
            </div>
            <p className="text-p-1 font-bold">{item.title}</p>
          </div>
        ))}
      </div>
    </>
  )
}
